import { OperatorsByIdsQueryResult } from "gql/generated";
import { getMultilingualString } from "./getMultilingualString";
import { getAddressString } from "./getAddressString";
import { TFunction } from "i18next";
import _ from "lodash";
import { getNameFromUser } from "./getNameFromUser";

export const mapOperatorCSVData = (
  t: TFunction<"translation", undefined>,
  data: OperatorsByIdsQueryResult["data"],
) =>
  _.compact(data?.operatorsByIds).map((op) => ({
    name: getMultilingualString(op.name),
    description: op.description ? getMultilingualString(op.description) : "",
    email: op.contact.email ?? "",
    phone: op.contact.phone ?? "",
    website: op.contact.links?.website ?? "",
    address: op.contact.address ? getAddressString(op.contact.address) : "",
    businessType: t(`core:LOOKUPS.OPERATOR_TYPE.${op.type}`),
    status: op.status ? t(`core:LOOKUPS.PUBLICATION_STATUS.${op.status}`) : "",
    pricing: op.pricing ? t(`core:LOOKUPS.OPERATOR_PRICING.${op.pricing}`) : "",
    backOfficeTags: op.tags
      ? op.tags.organizationSpecific
          .map((tag) => getMultilingualString(tag.name))
          .join(", ")
      : "",
    staff: op.staff
      .map((user) => `${getNameFromUser(user)}: ${user.email}`)
      .join(", "),
  }));
